import * as React from "react";
import { connect, Dispatch } from "react-redux";

import { reset } from "redux-form";

import { v4 as uuid } from "uuid";
import API from "../../vendor/api";

import { RootState } from "../../redux/index";
import { sendMessage, listenMessages, createGroupWithPatient, inviteUserToChat } from "../../redux/modules/appChats/appChats";

import Messages from "../Messages";
import SendMessageForm, { ISendMessageFields } from "../../components/Forms/SendMessage";
import { Header, Title } from "../../components/Header";
import Avatar from "../../components/Avatar";

import { setDialogStatus, selectSidebarView } from "../../redux/modules/ui/ui";

import SandwichMenu from "../../components/SandwichMenu";

import CreateGroupDialog from "../../components/Dialogs/CreateGroupDialog";

import { IChatNormalized, IUser } from "../../types/index";

const s = require("./chat.scss");

interface IChatProps {
    user: API.User;
    currentChat?: IChatNormalized;
    dispatch?: Dispatch<any>;
    isInviteToGroupDialogOpen: boolean;
    isCreateGroupWithPatientDialogOpen: boolean;
};

interface IChatState {
    doctors: IUser[];
};

class Chat extends React.Component<IChatProps, IChatState> {
    componentWillMount() {
        this.props.dispatch(listenMessages(new Date(), this.props.user));
    }

    sendMessage(fields: ISendMessageFields) {
        this.props.dispatch(sendMessage("_" + uuid(), fields.message, this.props.currentChat.id));
        this.props.dispatch(reset("SendMessageForm"));
    }

    /**
     * Open dialogs
     */

    onInviteToGroup() {
        this.props.dispatch(setDialogStatus("inviteToGroup", true));
    }

    onCreateGroupWithPatient() {
        this.props.dispatch(setDialogStatus("createGroupWithPatient", true));
    }

    /**
     * Action functions
     */

    inviteToGroup(doctors: string[], name: string) {
        const chatId = this.props.currentChat.id;
        const userId = doctors[0];
        this.props.dispatch(inviteUserToChat(chatId, userId));
        this.closeInviteToGroupDialog();
    }

    createGroupWithPatient(doctors: string[], name: string) {
        const patientId = this.props.currentChat.user.id;
        this.props.dispatch(createGroupWithPatient(name, doctors, [patientId]));
        this.closeCreateGroupWithPatientDialog();
    }

    openProfile(userId: string) {
        this.props.dispatch(selectSidebarView("profile"));
    }

    /**
     * Close Dialogs
     */

    closeInviteToGroupDialog() {
        this.props.dispatch(setDialogStatus("inviteToGroup", false));
    }

    closeCreateGroupWithPatientDialog() {
        this.props.dispatch(setDialogStatus("createGroupWithPatient", false));
    }

    componentDidMount() {
        API.getAllDoctors({}, 0).then(doctors => {
            this.setState({
                doctors
            });
        });
    }

    public render(): JSX.Element {
        const currentChat = this.props.currentChat;

        if (!currentChat) {
            return (
                <div className={s.chat}>
                    <div className={s.noChatSelected}>
                        <span>Selecione um chat ao lado para começar a conversar!</span>
                    </div>
                </div>
            );
        }

        const isGroup = currentChat.is_group;

        let image: string;
        let chat_user_options: any = [];

        if (isGroup) {
            image = (currentChat.avatar) ? currentChat.avatar.small_url : null;
        } else {
            chat_user_options = [
                {
                    label: "Ver perfil",
                    onClick: this.openProfile.bind(this, currentChat.user.id)
                }
            ];

            if (this.props.user.is_doctor) {
                chat_user_options.push({
                    label: "Criar grupo com este paciente",
                    onClick: this.onCreateGroupWithPatient.bind(this)
                });
            }
            
            image = (currentChat.user.avatar) ? currentChat.user.avatar.small_url : null;
        }



        return (
            <div className={s.chat}>
                <Header>
                    <div>
                        <Avatar
                            image={image}
                            group={isGroup}
                        />
                        <Title>{(isGroup) ? currentChat.name : currentChat.user.name}</Title>
                    </div>

                    {(isGroup) ? (
                        <div>
                            <SandwichMenu
                                options={[
                                    {
                                        label: "Convidar para o grupo",
                                        onClick: this.onInviteToGroup.bind(this)
                                    }
                                ]}
                                toTheLeft
                            />
                        </div>
                    ) : (
                        <div>
                            <SandwichMenu
                                options={chat_user_options}
                                toTheLeft
                            />
                        </div>
                    )}
                </Header>

                {
                    this.props.isInviteToGroupDialogOpen ?
                        <CreateGroupDialog
                            hideInputName
                            contacts={this.state.doctors}
                            onSubmit={this.inviteToGroup.bind(this)}
                            onCloseDialog={this.closeInviteToGroupDialog.bind(this)}
                        />
                    : null
                }

                {
                    this.props.isCreateGroupWithPatientDialogOpen ?
                        <CreateGroupDialog
                            contacts={this.state.doctors}
                            onSubmit={this.createGroupWithPatient.bind(this)}
                            onCloseDialog={this.closeCreateGroupWithPatientDialog.bind(this)}
                        />
                    : null
                }

                <Messages />

                <div className={s.sendMessageWrapper}>
                    <SendMessageForm
                        onSubmit={this.sendMessage.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

export default connect((state: RootState) => {
    let currentChat = state.entities.chats.byId[state.ui.chats.selected];
    let obj: IChatProps = {
        user: state.auth.user,
        isInviteToGroupDialogOpen: state.ui.dialogs.inviteToGroup,
        isCreateGroupWithPatientDialogOpen: state.ui.dialogs.createGroupWithPatient,
    };

    if (currentChat) {
        obj.currentChat = currentChat;
    }
    return obj;
})(Chat);



// WEBPACK FOOTER //
// ./src/containers/Chat/index.tsx